import SanitizedHtml from 'components/SanitizedHtml/SanitizedHtml'

export default SanitizedHtml
